import { render, staticRenderFns } from "./BlockBreadCrumbs.vue?vue&type=template&id=4ea97a46&scoped=true&"
import script from "./BlockBreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./BlockBreadCrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./BlockBreadCrumbs.vue?vue&type=style&index=0&id=4ea97a46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea97a46",
  null
  
)

export default component.exports